import './app-badge.ts';

export class AppTag extends HTMLElement {
    static get observedAttributes() {
        return ['tag', 'size'];
    }

    private _tag: any = null;

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue) {
            if (name === 'tag') {
                try {
                    this._tag = JSON.parse(newValue);
                } catch (e) {
                    this._tag = null;
                }
            }
            this.render();
        }
    }

    get tag() {
        return this._tag;
    }

    set tag(val: any) {
        this._tag = val;
        this.render();
    }

    render() {
        if (!this.shadowRoot) return;

        const size = this.getAttribute('size') || 'sm';
        const name = this._tag?.name || '';
        const color = this._tag?.metadata?.color || 'var(--accent)';
        const description = this._tag?.metadata?.description || '';

        if (description) {
            this.setAttribute('title', description);
            this.style.cursor = 'help';
            this.style.textDecoration = 'underline dashed rgba(255,255,255,0.3)';
            this.style.textUnderlineOffset = '4px';
        } else {
            this.removeAttribute('title');
            this.style.cursor = 'default';
            this.style.textDecoration = 'none';
        }

        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: inline-block;
                }
            </style>
            <app-badge size="${size}" color="${color}">
                ${name}
            </app-badge>
        `;
    }
}

customElements.define('app-tag', AppTag);
